import React from "react";
import { Link } from "react-router-dom";

function LabTestsByConcern() {
  const containerStyle = {
    padding: "60px 20px",
    fontFamily: "'Segoe UI', sans-serif",
    backgroundColor: "#f8f9fa",
  };

  const headingStyle = {
    textAlign: "center",
    fontSize: "36px",
    fontWeight: "700",
    color: "#3A8DF5",
    marginBottom: "40px",
  };

  const marqueeWrapper = {
    overflow: "hidden",
    width: "100%",
  };

  const marqueeTrack = {
    display: "flex",
    gap: "20px",
    width: "max-content",
    animation: "marquee 30s linear infinite",
  };

  const cardStyle = {
    width: "229px",
    minHeight: "260px",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
    textAlign: "center",
    padding: "20px 12px",
    cursor: "pointer",
    transition: "transform 0.3s ease",
  };

  const imageStyle = {
    width: "100%",
    height: "200px",
    objectFit: "contain",
    borderRadius: "12px",
    marginBottom: "16px",
  };

  const labelStyle = {
    fontSize: "16px",
    fontWeight: "600",
    color: "#222",
  };

  const badgeStyle = {
    fontSize: "12px",
    fontWeight: "600",
    color: "#fff",
    background: "#3A8DF5",
    padding: "4px 10px",
    borderRadius: "20px",
    display: "inline-block",
    marginTop: "6px",
  };

  const tests = [
    { name: "Full Body Checkups", badge: "Popular", img: "https://cms-contents.pharmeasy.in/homepage_top_categories_images/4cb2baf3234-Fullbody.png?dim=360x0" },
    { name: "Vitamins", badge: "Essentials", img: "https://cms-contents.pharmeasy.in/homepage_top_categories_images/e1a18d8deac-Vitamins.png?dim=360x0" },
    { name: "Diabetes", badge: "Specialist", img: "https://cms-contents.pharmeasy.in/homepage_top_categories_images/1e927857c26-Diabetes.png?dim=360x0" },
    { name: "Fever & Infection", badge: "Quick Care", img: "https://cms-contents.pharmeasy.in/homepage_top_categories_images/e1c60c444bf-Fever.png?dim=360x0" },
    { name: "Hair & Skin", badge: "Dermatology", img: "https://cms-contents.pharmeasy.in/homepage_top_categories_images/cd9606a9173-efr.png?dim=360x0" },
    { name: "Thyroid", badge: "Hormonal", img: "https://cms-contents.pharmeasy.in/homepage_top_categories_images/71fb3c06e71-Thyroid.png?dim=360x0" },
  ];

  return (
    <div style={containerStyle}>
      <h2 style={headingStyle}>Lab Tests by Health Concern</h2>

      <Link to="/shop" style={{ textDecoration: "none" }}>
        <div style={marqueeWrapper}>
          <div style={marqueeTrack}>
            {[...tests, ...tests].map((test, idx) => (
              <div key={idx} style={cardStyle}>
                <img src={test.img} alt={test.name} style={imageStyle} />
                <div style={labelStyle}>{test.name}</div>
                <div style={badgeStyle}>{test.badge}</div>
              </div>
            ))}
          </div>
        </div>
      </Link>

      {/* CSS Animation */}
      <style>
        {`
          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-50%);
            }
          }
        `}
      </style>
    </div>
  );
}

export default LabTestsByConcern;
